export const TEXT_SIZE_PRESETS = {
    md: {
        wrapper: 'prose max-w-none text-[16px]',
        thinkingWrapper: 'mt-1 pl-[14px] max-h-[180px] overflow-y-auto thinking-scroll text-sm opacity-65 space-y-1',
        userBubble: 'max-w-[85%] bg-app-hover rounded-2xl px-4 py-2.5',
        userBubbleText: 'text-[16px] whitespace-pre-wrap break-words',
        h1: 'text-[19px] font-semibold mt-5 mb-2 leading-[1.7] text-gray-900',
        h2: 'text-[17px] font-semibold mt-4 mb-2 leading-[1.7] text-gray-900',
        h3: 'text-[16px] font-semibold mt-3 mb-1.5 leading-[1.7] text-gray-900',
        h4: 'text-[15px] font-semibold mt-3 mb-1.5 leading-[1.7] text-gray-900',
        h5: 'font-semibold mt-2 mb-1 leading-[1.7] text-gray-900',
        h6: 'font-semibold mt-2 mb-1 leading-[1.7] text-gray-900',
        p: 'my-2 leading-[1.75] text-gray-700',
        ul: 'list-disc pl-6 leading-[1.75] my-2',
        ol: 'list-decimal pl-6 leading-[1.75] my-2',
        li: 'my-1 leading-[1.75] text-gray-700',
        blockquote: 'border-l-4 border-gray-300 pl-4 my-2 italic text-gray-600 leading-[1.75]',
        table: 'w-full border-separate border-spacing-0 text-sm rounded-xl overflow-hidden',
        tableWrapper: 'overflow-x-auto max-w-full table-scroll my-1 rounded-xl overflow-hidden',
        thBase: 'px-3 py-2.5 text-left font-semibold text-gray-700 whitespace-nowrap leading-[1.85]',
        tdBase: 'px-3 py-2.5 text-gray-600 border-t border-gray-100 leading-[1.85]',
        hr: 'mt-4 mb-3 border-gray-200',
        thinking: {
            h1: 'text-xl font-bold mt-1',
            h2: 'text-lg font-bold mt-1',
            h3: 'text-base font-bold mt-0.5',
            p: 'leading-snug',
            ul: 'list-disc ml-4 mb-2 space-y-1',
            ol: 'list-decimal ml-4 mb-2 space-y-1',
            li: 'text-gray-700',
            blockquote: 'border-l-4 border-gray-300 pl-3 italic text-gray-600',
        },
    },
    sm: {
        wrapper: 'prose prose-sm max-w-none text-[15px]',
        thinkingWrapper: 'mt-0.5 pl-[12px] max-h-[160px] overflow-y-auto thinking-scroll text-[13.5px] opacity-65 space-y-0',
        userBubble: 'max-w-[85%] bg-app-hover rounded-2xl px-3 py-1.5',
        userBubbleText: 'text-[15px] whitespace-pre-wrap break-words',
        h1: 'text-[15px] font-semibold mt-7 mb-3 leading-[1.5] text-gray-900',
        h2: 'text-[14px] font-semibold mt-6 mb-2.5 leading-[1.5] text-gray-900',
        h3: 'text-[13px] font-semibold mt-5 mb-2 leading-[1.5] text-gray-900',
        h4: 'text-[13px] font-semibold mt-4 mb-2 leading-[1.5] text-gray-900',
        h5: 'text-[12.5px] font-semibold mt-3.5 mb-1.5 leading-[1.5] text-gray-900',
        h6: 'text-[12.5px] font-semibold mt-3.5 mb-1.5 leading-[1.5] text-gray-900',
        p: 'my-3.5 leading-[1.75] text-[15px] text-gray-700',
        ul: 'list-disc pl-5 leading-[1.75] my-3.5',
        ol: 'list-decimal pl-5 leading-[1.75] my-3.5',
        li: 'my-2 leading-[1.75] text-[15px] text-gray-700',
        blockquote: 'border-l-4 border-gray-300 pl-3 my-3.5 italic text-gray-600 leading-[1.75] text-[15px]',
        table: 'w-auto min-w-full border-separate border-spacing-0 text-[13px] !my-0',
        tableWrapper: 'overflow-x-auto max-w-full table-scroll my-1 rounded-lg border border-gray-100',
        thBase: 'px-2 py-1 text-left font-semibold text-gray-700 whitespace-nowrap leading-[1.4] text-[13px]',
        tdBase: 'px-2 py-1 align-top text-gray-600 border-t border-gray-100 leading-[1.45] text-[13px] min-w-[140px] max-w-[320px] whitespace-normal break-words',
        hr: 'mt-5 mb-4 border-gray-200',
        thinking: {
            h1: 'text-[15px] font-bold mt-0.5',
            h2: 'text-[14px] font-bold mt-0.5',
            h3: 'text-[13.5px] font-bold mt-0',
            p: 'leading-snug text-[13.5px]',
            ul: 'list-disc ml-2.5 mb-1 space-y-0 text-[13.5px]',
            ol: 'list-decimal ml-2.5 mb-1 space-y-0 text-[13.5px]',
            li: 'text-gray-700 text-[13.5px]',
            blockquote: 'border-l-4 border-gray-300 pl-1.5 italic text-gray-600 text-[13.5px]',
        },
    },
};

export const DEFAULT_MARKDOWN_SIZE = 'md';

export function getTextSizePreset(size) {
    return TEXT_SIZE_PRESETS[size] || TEXT_SIZE_PRESETS[DEFAULT_MARKDOWN_SIZE];
}
